<script>
import { Bar } from "vue-chartjs";
import { HorizontalBar } from "vue-chartjs";

export default {
  name: "HorizontalBarChart",
  extends: HorizontalBar,
  props: {
    label: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: null
    }
  },
  mounted() {
    const options = {
      scales: {
        xAxes: [
          {
            ticks: {
              fontColor: "white"
            },
            scaleLabel: {
              display: true,
              labelString: this.label
            }
          }
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true,
              stepSize: 10,
              fontColor: "white",
            }
          }
        ]
      }
    };
    this.renderChart(this.data, options);
  }
};
</script>